import { render } from "./FormControlPage.vue?vue&type=template&id=cf804526&ts=true"
import script from "./FormControlPage.vue?vue&type=script&lang=ts"
export * from "./FormControlPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__